import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const StyledTableCellStrong = withStyles((theme) => ({
  head: {
    backgroundColor: '#FFF',
    fontWeight: 'bold'
  },
  body: {
    fontSize: 13,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 350
  },
  paper: {
    marginTop: 15
  }
});

function createData(peer, date1, date2, date3) {
  return { peer, date1, date2, date3 };
}

function createData2(impliedMulti, date1, date2, date3) {
  return { impliedMulti, date1, date2, date3 };
}

const rows = [
  createData('Uber Tech', '21.6x', '18.9x', '16.8x'),
  createData('Lyft', '20.0x', '18.5x', '17.0x')
];

const rows2 = [
  createData2('Low end', '18.6x', '17.1x', '15.8x'),
  createData2('High end', '21.0x', '19.0x', '17.2x')
];

const PeersMultiTable = () => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.paper} component={Paper}>
      <Table aria-label="a dense table" className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <StyledTableCellStrong>PEER</StyledTableCellStrong>
            <StyledTableCellStrong align="right">2019</StyledTableCellStrong>
            <StyledTableCellStrong align="right">2020</StyledTableCellStrong>
            <StyledTableCellStrong align="right">2021</StyledTableCellStrong>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.peer}>
              <TableCell component="th" scope="row">
                {row.peer}
              </TableCell>
              <TableCell align="right">{row.date1}</TableCell>
              <TableCell align="right">{row.date2}</TableCell>
              <TableCell align="right">{row.date3}</TableCell>
            </StyledTableRow>
          ))}

          <TableRow>
            <StyledTableCellStrong>Implied multiples</StyledTableCellStrong>
          </TableRow>
          {rows2.map((row) => (
            <StyledTableRow key={row.impliedLMulti}>
              <TableCell component="th" scope="row">
                {row.impliedMulti}
              </TableCell>
              <TableCell align="right">{row.date1}</TableCell>
              <TableCell align="right">{row.date2}</TableCell>
              <TableCell align="right">{row.date3}</TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PeersMultiTable;
